import './App.css';
import 'primeicons/primeicons.css';
import Guestbook from './Guestbook';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Games from './Games';
import NotFound from './NotFound';
import { useMemo } from 'react';
import { getRootLocation } from './util/Util';
import GameDetail from './GameDetail';
import Home from './Home';
import Imprint from './Imprint';
import Privacy from './Privacy';
import Conditions from './Conditions';
import { AbenteuerpaketeApi } from './api/AbenteuerpaketeApi';
import About from './About';
import Contact from './Contact';

function App() {

  const api = useMemo(() => new AbenteuerpaketeApi({baseUrl: "/wp-json"}), []);

  const rootDir = getRootLocation();

  return (
    <div className="App">
      <BrowserRouter >
        <Header/>
        <Routes>
          <Route path={rootDir} element={<Home/>} />
          <Route path={rootDir + 'guestbook'} element={<Guestbook api={api}/>} />
          <Route path={rootDir + 'games'} element={<Games api={api}/>} />
          <Route path={rootDir + 'games/:id'} element={<GameDetail api={api} />} />
          <Route path={rootDir + 'about'} element={<About api={api}/>} />
          <Route path={rootDir + 'imprint'} element={<Imprint api={api}/>} />
          <Route path={rootDir + 'privacy'} element={<Privacy api={api}/>} />
          <Route path={rootDir + 'conditions'} element={<Conditions api={api}/>} />
          <Route path={rootDir + 'contact'} element={<Contact api={api}/>} />
          <Route path='*' element={<NotFound/>} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
